import { Outlet } from 'react-router';
import { Header } from '@/app/header/Header';
import './HomeLayout.scss';

/** Angular HomeComponent: the fixed header above the routed screen. */
export function HomeLayout() {
  return (
    <div className="main-wrapper">
      <div className="header-wrapper">
        <div className="navigation-container">
          <Header />
          <Outlet />
        </div>
      </div>
    </div>
  );
}
